import { DateTime } from 'luxon'

///////////////////////////////////
// Types
///////////////////////////////////

export const BillingCategoryCode = {
  ConvenienceStore: '01',
  CreditCard: '02',
  AccountTransfer: '03',
  DirectTransfer: '04',
  Other: '05', // 現金・その他
} as const
export type BillingCategoryCode = (typeof BillingCategoryCode)[keyof typeof BillingCategoryCode]

export const billingCategoryCodeText = (code: BillingCategoryCode) => {
  switch (code) {
    case BillingCategoryCode.ConvenienceStore:
      return 'コンビニ払い'
    case BillingCategoryCode.CreditCard:
      return 'クレジットカード払い'
    case BillingCategoryCode.AccountTransfer:
      return '口座振替'
    case BillingCategoryCode.DirectTransfer:
      return '直接振込'
    case BillingCategoryCode.Other:
      return '現金・その他の方法'
  }
}

///////////////////////////////////
// Receipt
///////////////////////////////////

export type ReceiptData = {
  year: number
  month: number
  billingName: string
  billingHonorific: string
  paymentDate: string
  paymentAmount: number
  consumption: number
  roomType: string
  basicCapacity: string
  basicCapacityUnit: string | null
  minimumFeeSystemConsumption: number
  billingCategoryCode: BillingCategoryCode
}

export default class Receipt {
  declare year: number
  declare month: number
  declare billingName: string
  declare billingHonorific: string
  declare paymentDate: DateTime
  declare paymentAmount: number
  declare consumption: number
  declare roomType: string
  declare basicCapacity: string
  declare basicCapacityUnit: string | null
  declare minimumFeeSystemConsumption: number
  declare billingCategoryCode: BillingCategoryCode

  // Computed properties --------------------------------------------------------------

  get formattedBillingDate() {
    const date = DateTime.fromObject({ year: this.year, month: this.month, day: 1 })
    return date.toLocaleString({ year: 'numeric', month: 'long' }, { locale: 'ja-JP-u-ca-japanese' })
  }

  get billingCategoryCodeText() {
    return billingCategoryCodeText(this.billingCategoryCode)
  }

  // Constructor -----------------------------------------------------------------------

  constructor(params: ReceiptData) {
    Object.assign(this, params)
    this.paymentDate = DateTime.fromISO(params.paymentDate)
  }
}
